<template>
  <el-dialog
    :title="'门店方案模板'"
    :visible.sync="innerVisible"
    width="70%"
    @close="onClose"
  >
    <div class="header-search">
      <el-form inline :model="searchData">
        <el-form-item label="模板名称">
          <el-input
            v-model.trim="searchData.templateName"
            size="small"
            placeholder="请输入"
            class="search-form-item"
          />
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="handleSearch"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="handleReset"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="template-bind-toolbar">
      <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
    </div>

    <el-row :gutter="16" class="card-list" v-loading="table.loading">
      <el-col
        v-for="item in table.list"
        :key="item.id"
        :span="6"
        class="card-list-item"
      >
        <el-card
          shadow="hover"
          class="template-card"
          :class="{ 'is-active': selectedTplId === item.id }"
          @click.native="onChooseCard(item)"
        >
          <div class="card-head">
            <span class="card-title">方案列表</span>
          </div>
          <div class="card-body">
            <div
              v-for="(plan, idx) in item.planList"
              :key="`${item.id}-${idx}`"
              class="plan-item"
            >
              {{ plan }}
            </div>
          </div>
          <div class="card-footer">
            <div class="template-name">{{ item.templateName }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="table.currentPage"
        :page-size="table.pageSize"
        :total="table.total"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getComboTemplatePageAPI, bindStoreTemplateAPI } from "../api";

export default {
  name: "StoreTemplateBindDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    storeIdList: {
      type: Array,
      default: () => [],
    },
    storeId: {
      type: [Number, String],
      default: null,
    },
    currentTplId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      innerVisible: false,
      selectedTplId: null,
      searchData: {
        templateName: "",
      },
      table: {
        currentPage: 1,
        pageSize: 8,
        total: 0,
        loading: false,
        list: [],
      },
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.selectedTplId = this.currentTplId || null;
          this.searchData.templateName = "";
          this.table.currentPage = 1;
          this.getList();
        }
      },
    },
    "table.currentPage"() {
      if (!this.innerVisible) {
        return;
      }
      this.getList();
    },
  },
  methods: {
    mapCardItem(item) {
      const comboList = item.comboList || [];
      return {
        id: item.id,
        templateName: item.tplName || "",
        planList: comboList.map((combo) => combo.comboName).filter(Boolean),
      };
    },
    async getList() {
      this.table.loading = true;
      try {
        const res = await getComboTemplatePageAPI({
          page: this.table.currentPage,
          pageSize: this.table.pageSize,
          tplName: this.searchData.templateName || undefined,
        });
        this.table.list = (res.list || []).map(this.mapCardItem);
        this.table.total = res.total || 0;
      } finally {
        this.table.loading = false;
      }
    },
    onChooseCard(item) {
      this.selectedTplId = item.id;
    },
    handleSearch() {
      if (this.table.currentPage !== 1) {
        this.table.currentPage = 1;
        return;
      }
      this.getList();
    },
    handleReset() {
      this.searchData.templateName = "";
      if (this.table.currentPage !== 1) {
        this.table.currentPage = 1;
        return;
      }
      this.getList();
    },
    async onSubmit() {
      if (!this.selectedTplId) {
        this.$message.error("请选择方案模板");
        return;
      }
      const targetStoreIdList = this.storeIdList.length
        ? this.storeIdList
        : this.storeId
          ? [this.storeId]
          : [];
      if (!targetStoreIdList.length) {
        this.$message.error("请选择门店");
        return;
      }
      await bindStoreTemplateAPI({
        storeIdList: targetStoreIdList,
        tplId: String(this.selectedTplId),
      });
      this.$message.success("保存成功");
      this.$emit("saved");
      this.onClose();
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.template-bind-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.card-list-item {
  margin-bottom: 16px;
}

.template-card {
  cursor: pointer;
  border: 1px solid #ebeef5;

  &.is-active {
    border-color: #409eff;
    box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.3);
  }

  .card-head {
    margin-bottom: 8px;
    .card-title {
      font-size: 14px;
      font-weight: 600;
    }
  }

  .card-body {
    height: 140px;
    border: 1px solid #ebeef5;
    padding: 8px 10px;
    overflow-y: auto;

    .plan-item {
      line-height: 28px;
      color: #606266;
      border-bottom: 1px dashed #ebeef5;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .card-footer {
    margin-top: 10px;
    .template-name {
      font-weight: 500;
    }
  }
}
</style>
